module.exports = __webpack_public_path__ + "static/media/5f8de7ec5ae7590275f07444_banner_800x600.8e916d59.png";